<form class="drop-padding" (ngSubmit)="addImage()">
  <mat-form-field appearance="outline">
    <mat-label>Ссылки</mat-label>
    <textarea matInput type="text" placeholder="Ссылки" [formControl]="imageFormControl"></textarea>
  </mat-form-field>
  <button mat-flat-button color="primary" type="submit">Сохранить</button>
</form>
